<svelte:options tag="w-filteritem"/>
<script>
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    const handleChange = (e) => {

        const selected = e.target.value
        const field = e.target.id

        const params = {
            field,
            selected
        }

        dispatch('filterChanged', params)
	};

    export let field = '';
    export let header = '';
    export let title = 'title';
    export let selected = '';
    export let list = [];
    export let id = null;
    export let value = null;

</script>

<div class="form-group">
    <label for="category">{header}</label>
    <select value="{selected}" on:change="{handleChange}" class="form-control" id={field}>
        <option value="">{title}</option>
        {#each list as item}
            <option value="{id ? item[id] : item}">{value ? item[value] : item}</option>
        {/each}
    </select>
</div>